(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.collapsible-text').forEach(function (block) {
    const button = block.parentNode.querySelector('.toggle-text-btn');

    if (!button) return;

    // Mostra il pulsante solo se il testo supera l'altezza minima
    if (block.scrollHeight > block.clientHeight) {
      button.style.display = 'inline-block';
    }

    button.addEventListener('click', function () {
      block.classList.toggle('expanded');
      button.textContent = block.classList.contains('expanded')
        ? 'Mostra meno'
        : 'Scopri di più';
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
